import React from 'react';
import dayjs from 'dayjs';
import { setColumnSort } from '../../../libs/utils';
import TrainerPopover from './trainer_popover';
//----------------------------------------------------------------------------------------------------
// images
import ico_more from '../../../assets/images/ico_more.png';
//----------------------------------------------------------------------------------------------------
const centerIcons = [
  require('../../../assets/images/ico_center_01.png'),
  require('../../../assets/images/ico_center_02.png'),
  require('../../../assets/images/ico_center_03.png'),
  require('../../../assets/images/ico_center_04.png'),
  require('../../../assets/images/ico_center_05.png'),
  require('../../../assets/images/ico_center_06.png'),
  require('../../../assets/images/ico_center_07.png'),
  require('../../../assets/images/ico_center_08.png'),
  require('../../../assets/images/ico_center_09.png'),
  require('../../../assets/images/ico_center_10.png'),
];
//----------------------------------------------------------------------------------------------------
const TrainerColumns = (props) => {
  const { sorts, setSorts, loading, setLoading, OnCellClick, ...rests } = props;

  return [
    {
      title: (filters, sortOrder) => {
        return (
          <div
            onClick={(e) => {
              setSorts((prev) => setColumnSort(prev, 'account_name'));
            }}
            style={{ ...styles.col_headers }}
          >
            {'성명'}
          </div>
        );
      },
      width: 230,
      dataIndex: 'account_name',
      key: 'account_name',
      sorter: true,
      render: (value, obj) => (
        <div
          style={{ ...styles.col_text }}
          onClick={(e) => {
            OnCellClick({ id: obj.account_id });
          }}
        >
          {value}
          <div style={{ ...styles.col_text, color: 'red' }}>
            {`${obj?.is_valid == 0 ? '' : '(활동정지)'}`}
          </div>
        </div>
      ),
    },
    /* ---------- */
    {
      title: (filters, sortOrder) => {
        return (
          <div
            onClick={(e) => {
              setSorts((prev) => setColumnSort(prev, 'account_email'));
            }}
            style={{ ...styles.col_headers }}
          >
            {'이메일(ID)'}
          </div>
        );
      },
      width: 230,
      dataIndex: 'account_email',
      key: 'account_email',
      sorter: true,
      render: (value, obj) => (
        <div
          style={{ ...styles.col_text }}
          onClick={(e) => {
            OnCellClick({ id: obj.account_id });
          }}
        >
          {value}
        </div>
      ),
    },
    /* ---------- */
    {
      // title: '센터명',
      title: (filters, sortOrder) => {
        return (
          <div
            onClick={(e) => {
              setSorts((prev) => setColumnSort(prev, 'center_name'));
            }}
            style={{ ...styles.col_headers }}
          >
            {'센터명'}
          </div>
        );
      },
      sorter: true,
      width: 207,
      dataIndex: 'center_name',
      key: 'center_name',
      render: (value, obj, seq) => {
        return (
          <div
            style={{ ...styles.col1 }}
            onClick={(e) => {
              OnCellClick({ id: obj.account_id });
            }}
          >
            <img width={24} height={24} src={centerIcons[seq]} />
            <div style={{ ...styles.col1_text }}>{value}</div>
          </div>
        );
      },
      // fixed: 'left',
      /* sorter: (a, b) => {
        return a.age - b.age;
       },
      */
    },
    {
      // title: '센터명',
      title: (filters, sortOrder) => {
        return (
          <div
            onClick={(e) => {
              setSorts((prev) => setColumnSort(prev, 'account_phone'));
            }}
            style={{ ...styles.col_headers }}
          >
            {'전화번호'}
          </div>
        );
      },
      sorter: true,
      width: 150,
      dataIndex: 'account_phone',
      key: 'account_phone',
      render: (value, obj, seq) => {
        return (
          <div
            style={{ ...styles.col1 }}
            onClick={(e) => {
              OnCellClick({ id: obj.account_id });
            }}
          >
            {value}
          </div>
        );
      },
      // fixed: 'left',
      /* sorter: (a, b) => {
        return a.age - b.age;
       },
      */
    },
    /* ---------- */
    {
      title: (filters, sortOrder) => {
        return (
          <div
            onClick={(e) => {
              setSorts((prev) => setColumnSort(prev, 'sequence_count'));
            }}
            style={{ ...styles.col_headers }}
          >
            {'시퀀스'}
          </div>
        );
      },
      width: 107,
      dataIndex: 'sequence_count',
      key: 'sequence_count',
      sorter: true,
      render: (value, obj) => (
        <div
          style={{ ...styles.col_text }}
          onClick={(e) => {
            OnCellClick({ id: obj.account_id });
          }}
        >
          {value}
        </div>
      ),
    },
    /* ---------- */
    {
      title: (filters, sortOrder) => {
        return (
          <div
            onClick={(e) => {
              setSorts((prev) => setColumnSort(prev, 'tempo_count'));
            }}
            style={{ ...styles.col_headers }}
          >
            {'템포'}
          </div>
        );
      },
      width: 130,
      dataIndex: 'tempo_count',
      key: 'tempo_count',
      sorter: true,
      render: (value, obj) => (
        <div
          style={{ ...styles.col_text }}
          onClick={(e) => {
            OnCellClick({ id: obj.account_id });
          }}
        >
          {value}
        </div>
      ),
    },
    /* ---------- */
    {
      title: (filters, sortOrder) => {
        return (
          <div
            onClick={(e) => {
              setSorts((prev) => setColumnSort(prev, 'lecture_count'));
            }}
            style={{ ...styles.col_headers }}
          >
            {'강의'}
          </div>
        );
      },
      width: 130,
      dataIndex: 'lecture_count',
      key: 'lecture_count',
      sorter: true,
      render: (value, obj) => (
        <div
          style={{ ...styles.col_text }}
          onClick={(e) => {
            OnCellClick({ id: obj.account_id });
          }}
        >
          {value}
        </div>
      ),
    },
    /* ---------- */
    {
      title: (filters, sortOrder) => {
        return (
          <div
            onClick={(e) => {
              setSorts((prev) => setColumnSort(prev, 'created_at'));
            }}
            style={{ ...styles.col_headers }}
          >
            {'가입일'}
          </div>
        );
      },
      width: 112,
      dataIndex: 'created_at',
      key: 'created_at',
      sorter: true,
      render: (value, obj) => {
        return (
          <div
            style={{ ...styles.col_text }}
            onClick={(e) => {
              OnCellClick({ id: obj.account_id });
            }}
          >
            {(value && dayjs(value).format('YYYY.MM.DD')) || '-'}
          </div>
        );
      },
    },
    /* ---------- */
    {
      title: (filters, sortOrder) => {
        return (
          <div
            onClick={(e) => {
              setSorts((prev) => setColumnSort(prev, 'is_valid'));
            }}
            style={{ ...styles.col_headers }}
          >
            {'권한 상태'}
          </div>
        );
      },
      width: 130,
      dataIndex: 'is_valid',
      key: 'is_valid',
      sorter: true,
      render: (value, obj) => {
        let statusStyles = { ...styles.col_plan };
        // is_valid는 잘못된 사용에 대한 누적 카운드 개념ㄴ
        // 0 ~ 2 정상   3:정지

        if (value == 3) {
          //'비활성'
          statusStyles = {
            ...statusStyles,
            background: '#4B4B4B',
            color: '#FFF',
          };
        }

        return (
          <div
            style={{ ...statusStyles }}
            onClick={(e) => {
              OnCellClick({ id: obj.account_id });
            }}
          >
            {value == 3 ? `비활성` : '활성'}
          </div>
        );
      },
    },
    /* ---------- */
    {
      // more
      title: (
        <div
          style={{
            display: 'flex',
            width: '3rem',
            flexDirection: 'column',
            justifyContetn: 'center',
            alignItems: 'center',
          }}
        >
          <img width={22} height={22} src={ico_more} />
        </div>
      ),
      width: 30,
      // height: 48,
      render: (value, obj) => {
        const accountId = obj.account_id;
        const adminName = obj.account_name;
        const centerName = obj.center_name;
        const isValid = obj.is_valid == 3 ? 'F' : 'T';

        return (
          <TrainerPopover
            {...props}
            accountId={accountId}
            adminName={adminName}
            centerName={centerName}
            isValid={isValid}
            width={30}
            component={<img width={22} height={22} src={ico_more} />}
          />
        );
      },
      fixed: 'right',
    },
  ];
};

//----------------------------------------------------------------------------------------------------
const styles = {
  col_headers: {
    fontFamily: 'Public Sans',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '1.3rem',
    lineHeight: '1.5rem',
    letterSpacing: 1,
    textTransform: 'uppercase',
  },
  col1: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  col1_text: {
    display: 'flex',
    marginLeft: '1rem',
    wordWrap: true,

    // font
    fontFamily: 'Public Sans',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '1.5rem',
    lineHeight: '2.2rem',
  },
  col_text: {
    display: 'flex',
    marginLeft: '1rem',
    wordWrap: true,

    // font
    fontFamily: 'Public Sans',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '1.5rem',
    lineHeight: '2.2rem',
  },
  col_plan: {
    display: 'flex',
    width: '9.6rem',
    height: '2.4rem',
    wordWrap: true,
    gap: '1rem',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '5px 10px',
    background: 'rgba(40, 199, 111, 0.16)',
    borderRadius: 4,
    color: '#28C76F',
  },
};

export default TrainerColumns;
